export const DEPARTS = 'departs';
export const ARRIVES = 'arrives';
export const MINUTES = 'minutes';
export const HOURS = 'hours';
export const BEFORE = 'before';
export const AFTER = 'after';
export const FIRST = 'first';
export const LAST = 'last';
export const DATE = 'date';
export const DEPARTURE_DATE = 'departureDate';
export const ARRIVAL_DATE = 'arrivalDate';
export const MINIMUM_CONNECTION_TIME_MINUTES = 9;
